import component from './ChappedLayout';

export default component;
